import $ from "jquery";
import objectFitImages from "object-fit-images";

const isMobile = window.matchMedia("(max-width: 767px)");
const defaults = {
    selector: {
        module: ".js-solutions",
        trigger: ".js-solutions-trigger",
        content: ".solutions__nav-content-inner",
    },
    state: {
        active: "is-active",
    },
};

let options;

function scrollIntoViewHandler($element) {
    $element.one("transitionend", () => {
        $element.get(0).scrollIntoView({ behavior: "smooth", block: "start" });
    });
}

function fixHeight($module, $initActiveElm) {
    const $active = $module.find("." + options.state.active);

    // Restore initial state if no active
    if (!isMobile.matches && $active.length === 0) {
        $initActiveElm.addClass(options.state.active);
    }

    // Calculate heights
    const height = $active.find(options.selector.content).outerHeight();
    $module.css("height", height);
}

function solutionOnClick(event) {
    event.preventDefault();

    const $solution = $(this).parent();

    if ($solution.hasClass(options.state.active) && isMobile.matches) {
        $solution.removeClass(options.state.active);
        // Scroll back to container module
        scrollIntoViewHandler($solution.parent().parent());
    } else {
        $solution
            .addClass(options.state.active)
            .siblings()
            .removeClass(options.state.active);
        if (isMobile.matches) {
            scrollIntoViewHandler($solution);
        }
    }
}

function init(opts = {}) {
    // merge options
    options = $.extend(true, defaults, opts);

    // cache elements
    const $module = $(options.selector.module);
    const $initActiveElm = $module.find("." + options.state.active);

    // if no module find, return
    if (!$module.length) return;

    // TODO: Remove this line and add the logic in cshtml file
    $initActiveElm
        .find("img")
        .attr("src", $initActiveElm.find("img").attr("data-src"))
        .each(function () {
            objectFitImages(this);
        });

    // No initial active state on mobile
    if (isMobile.matches) {
        $initActiveElm.removeClass(options.state.active);
    }

    // bind event handlers
    $module.on("click", options.selector.trigger, function () {
        solutionOnClick.call(this, event);
        fixHeight($module, $initActiveElm);
    });
    fixHeight($module, $initActiveElm);

    // load images
    $module.one("mouseenter", () => {
        $module.find("img").each(function () {
            $(this).attr("src", $(this).attr("data-src"));
            objectFitImages(this);
        });
    });

    // resize height scaling
    let debounceTimer;
    $(window).on("resize.solutions", function () {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(
            () => fixHeight($module, $initActiveElm),
            250,
        );
    });
}

export default {
    init,
};
